import { render } from "./AgentLoginSummary.vue?vue&type=template&id=48c09d24&scoped=true"
import script from "./AgentLoginSummary.vue?vue&type=script&lang=js"
export * from "./AgentLoginSummary.vue?vue&type=script&lang=js"

import "./AgentLoginSummary.vue?vue&type=style&index=0&id=48c09d24&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c09d24"]])

export default __exports__